import {
  ClientCookieAdapter,
  GeneralizedCookieClient,
  GeoLocationApi,
  wrapAxios
} from '@carvana/merch-geolocation';
import { axios, httpWithAuth } from '~/clients';
import {
  CONTACTS,
  GEOLOCATION,
  LOCATION_INFORMATION_FROM_ZIP
} from '~/constants/endpoints';
import { generateErrorLogger } from '~/utilities/loggers';

export default function getGeolocationApi(): GeoLocationApi {
  const cookieAdapter = new ClientCookieAdapter(window.document);
  const cookieClient = new GeneralizedCookieClient(cookieAdapter);

  return new GeoLocationApi(
    cookieClient,
    {
      contactsApi: CONTACTS,
      contextApi: LOCATION_INFORMATION_FROM_ZIP,
      geolocationApi: GEOLOCATION,
      onError: () => generateErrorLogger('Get Geo Location')
    },
    wrapAxios(axios),
    wrapAxios(httpWithAuth)
  );
}
